/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListUserSessionsResult,
  ListUserSessionsResult$inboundSchema,
} from "../components/listusersessionsresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListUserSessionsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListUserSessionsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListUserSessionsSecurity = {
  option1?: ListUserSessionsSecurityOption1 | undefined;
  option2?: ListUserSessionsSecurityOption2 | undefined;
};

/**
 * Filter by session status.
 */
export const ListUserSessionsQueryParamStatus = {
  Active: "active",
  Expired: "expired",
  Revoked: "revoked",
  All: "all",
} as const;
/**
 * Filter by session status.
 */
export type ListUserSessionsQueryParamStatus = ClosedEnum<
  typeof ListUserSessionsQueryParamStatus
>;

export type ListUserSessionsRequest = {
  /**
   * Exact-match filter on subject URN.
   */
  subjectUrn?: string | undefined;
  /**
   * Filter by user_session_issuer id.
   */
  userSessionIssuerId?: string | undefined;
  /**
   * Filter by session status.
   */
  status?: ListUserSessionsQueryParamStatus | undefined;
  /**
   * Filter by the connecting client id.
   */
  clientId?: string | undefined;
  /**
   * Pagination cursor: id of the last item from the previous page.
   */
  cursor?: string | undefined;
  /**
   * Page size (default 50, max 100).
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type ListUserSessionsResponse = {
  result: ListUserSessionsResult;
};

/** @internal */
export type ListUserSessionsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListUserSessionsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListUserSessionsSecurityOption1$Outbound,
  ListUserSessionsSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listUserSessionsSecurityOption1ToJSON(
  listUserSessionsSecurityOption1: ListUserSessionsSecurityOption1,
): string {
  return JSON.stringify(
    ListUserSessionsSecurityOption1$outboundSchema.parse(
      listUserSessionsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListUserSessionsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListUserSessionsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListUserSessionsSecurityOption2$Outbound,
  ListUserSessionsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listUserSessionsSecurityOption2ToJSON(
  listUserSessionsSecurityOption2: ListUserSessionsSecurityOption2,
): string {
  return JSON.stringify(
    ListUserSessionsSecurityOption2$outboundSchema.parse(
      listUserSessionsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListUserSessionsSecurity$Outbound = {
  Option1?: ListUserSessionsSecurityOption1$Outbound | undefined;
  Option2?: ListUserSessionsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListUserSessionsSecurity$outboundSchema: z.ZodMiniType<
  ListUserSessionsSecurity$Outbound,
  ListUserSessionsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListUserSessionsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListUserSessionsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listUserSessionsSecurityToJSON(
  listUserSessionsSecurity: ListUserSessionsSecurity,
): string {
  return JSON.stringify(
    ListUserSessionsSecurity$outboundSchema.parse(listUserSessionsSecurity),
  );
}

/** @internal */
export const ListUserSessionsQueryParamStatus$outboundSchema: z.ZodMiniEnum<
  typeof ListUserSessionsQueryParamStatus
> = z.enum(ListUserSessionsQueryParamStatus);

/** @internal */
export type ListUserSessionsRequest$Outbound = {
  subject_urn?: string | undefined;
  user_session_issuer_id?: string | undefined;
  status?: string | undefined;
  client_id?: string | undefined;
  cursor?: string | undefined;
  limit?: number | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListUserSessionsRequest$outboundSchema: z.ZodMiniType<
  ListUserSessionsRequest$Outbound,
  ListUserSessionsRequest
> = z.pipe(
  z.object({
    subjectUrn: z.optional(z.string()),
    userSessionIssuerId: z.optional(z.string()),
    status: z.optional(ListUserSessionsQueryParamStatus$outboundSchema),
    clientId: z.optional(z.string()),
    cursor: z.optional(z.string()),
    limit: z.optional(z.int()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      subjectUrn: "subject_urn",
      userSessionIssuerId: "user_session_issuer_id",
      clientId: "client_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listUserSessionsRequestToJSON(
  listUserSessionsRequest: ListUserSessionsRequest,
): string {
  return JSON.stringify(
    ListUserSessionsRequest$outboundSchema.parse(listUserSessionsRequest),
  );
}

/** @internal */
export const ListUserSessionsResponse$inboundSchema: z.ZodMiniType<
  ListUserSessionsResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListUserSessionsResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listUserSessionsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListUserSessionsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListUserSessionsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListUserSessionsResponse' from JSON`,
  );
}
